module.exports = __webpack_public_path__ + "static/media/1024x1024.6c82a875.png";